import styled, { keyframes } from 'styled-components';
import { fromMd, untilMd } from '../../themes/default';
import { FadeTransitionImage } from '../FadeTransitionImage';
import { Skeleton } from '../Skeleton';
export const Body = styled.div `
  height: 100%;
  z-index: ${o => o.theme.zIndex.foregroundContent - 1};
  overflow: hidden;
`;
const appearAnimation = keyframes `
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1
  }
`;
export const BackgroundImage = styled(FadeTransitionImage) `
  height: 100%;
  animation: ${appearAnimation} 0.5s ease-in-out normal;
  ${untilMd} {
    &::after {
      content: '';
      display: block;
      padding-bottom: 100%;
    }
  }
`;
export const ImageSkeleton = styled(Skeleton) `
  ${untilMd} {
    position: absolute;
    width: 100%;
  }

  ${fromMd} {
    display: none;
  }
`;
//# sourceMappingURL=styles.js.map